jQuery($ => {
	const $header = $('#header');
	const $mobileMenuContent = $('.mobile-menu-content');
	$header.find('.mobile-menu-opener').click(function (e) {
		e.preventDefault();
		$header.toggleClass('has-open-mobile-menu');
		if ($header.hasClass('has-open-mobile-menu')) {
			$(document.body).addClass('scroll-lock');
			$mobileMenuContent.attr('data-page', '1');
		} else {
			$(document.body).removeClass('scroll-lock');
		}
		$('#mobileMenuPopup').slideToggle();
	});

	$mobileMenuContent.find('.menu-l1 .has-submenu a').click(function (e) {
		e.preventDefault();
		const id = $(this).closest('li').data('id');
		const $matchingSubmenu = $mobileMenuContent.find(`.menu-l2[data-id="${id}"]`);
		if ($matchingSubmenu.length) {
			$matchingSubmenu.show().siblings('ul').hide().prevAll('.menu-title').children('.title').text($(this).text());
			$mobileMenuContent.attr('data-page', '2');

		}
	});
	$mobileMenuContent.find('.menu-l2 .has-submenu a').click(function (e) {
		e.preventDefault();
		const id = $(this).closest('li').data('id');
		const $matchingSubmenu = $mobileMenuContent.find(`.menu-l3[data-id="${id}"]`);
		if ($matchingSubmenu.length) {
			$matchingSubmenu.show().siblings('ul').hide().prevAll('.menu-title').children('.title').text($(this).text());
			$mobileMenuContent.attr('data-page', '3');
		}
	});

	$mobileMenuContent.find('a.back').click(function (e) {
		e.preventDefault();
		const currentPage = parseInt($mobileMenuContent.attr('data-page')) || 2;
		$mobileMenuContent.attr('data-page', currentPage - 1);
		setTimeout(() => {
			$mobileMenuContent.find(`.menu-l${currentPage}`).hide();
		}, 300);
	});
});
